import { render, staticRenderFns } from "./CoverageCategoryGroup.vue?vue&type=template&id=788efcac&scoped=true"
import script from "./CoverageCategoryGroup.vue?vue&type=script&lang=js"
export * from "./CoverageCategoryGroup.vue?vue&type=script&lang=js"
import style0 from "./CoverageCategoryGroup.vue?vue&type=style&index=0&id=788efcac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788efcac",
  null
  
)

export default component.exports